exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#classManage[data-v-4f63583f]{padding-bottom:20px}.cancel[data-v-4f63583f]{position:absolute;right:20px}.addClass[data-v-4f63583f]{right:90px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4f63583f&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/classManage.vue
// module id = 524
// module chunks = 0